import { Spacing } from "../../../foundations/spacing.es.js";
import { Common } from "../../../foundations/palette.es.js";
const commonStyle = {
  padding: `${Spacing["250"]} ${Spacing["1000"]}`,
  background: Common.dark.main
};
const toolTipStyleOverrides = {
  tooltipArrow: {
    ...commonStyle
  },
  tooltip: {
    ...commonStyle
  },
  arrow: {
    color: Common.dark.main
  }
};
export {
  toolTipStyleOverrides
};
//# sourceMappingURL=tooltip.es.js.map
